import { render, staticRenderFns } from "./UpdatePrivacyPolicyInformation.vue?vue&type=template&id=3fd1edf2"
import script from "./UpdatePrivacyPolicyInformation.vue?vue&type=script&lang=js"
export * from "./UpdatePrivacyPolicyInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports